import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { FormattedMessage } from "react-intl";
import ContentBox from "../../ContentBox";
import ContentListItem from "../../ContentListItem";
import ChatIcon from "@material-ui/icons/Chat";
import { List } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { TaskListItem } from "./TaskListItem";
import { useTasks } from "./useTasks";
const Todos = (props) => {
    const { boxProps, applicationsSearchPath, setApplicationsSearchParams, showEmptyResult, placeholder } = props;
    const animation = !placeholder && undefined;
    const tasks = useTasks(!placeholder
        ? props.tasks
        : [
            {
                icon: (_jsx(Skeleton, { animation: animation, variant: "circle", width: 40, height: 40 })),
                filter: {},
                id: ".",
                name: ".",
                primaryMessage: ".",
                secondaryMessage: "."
            }
        ], placeholder);
    return (_jsx(ContentBox, { avatar: _jsx(ChatIcon, {}), header: _jsx(FormattedMessage, { id: "dealer.dashboard.todolist.header", defaultMessage: "To-do list", description: "Header for todolist on dashboard." }), ...boxProps, children: _jsx(List, { component: "nav", dense: true, children: tasks.map(task => {
                const fallback = (_jsx(ContentListItem, { iconClass: task.iconClass, icon: task.icon, primary: _jsx(Skeleton, { animation: animation, variant: "text", width: "60%" }), secondary: task.secondaryMessage?.trim() && (_jsx(Skeleton, { animation: animation, variant: "text", width: "90%" })), inset: true, hideChevron: true }, task.id ?? task.name));
                if (placeholder)
                    return fallback;
                return (_jsx(Suspense, { fallback: fallback, children: _jsx(TaskListItem, { ...task, inset: true, showEmptyResult: showEmptyResult, applicationsSearchPath: applicationsSearchPath, setApplicationsSearchParams: setApplicationsSearchParams }) }, task.id ?? task.name));
            }) }) }));
};
Todos.displayName = "DployDashboardTodos";
export default Todos;
//# sourceMappingURL=Todos.js.map